const data = {
	"body": "<path fill=\"currentColor\" d=\"M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8a8 8 0 0 1-8 8Z\"/><path fill=\"currentColor\" d=\"M16 11h-3V8a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 0 0 0-2Z\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
